import React from 'react';
import { Button } from '@rentspree/component-2023.components.atoms.button';
import { Typography } from '@rentspree/component-2023.components.atoms.typography';
import { Card } from '@rentspree/component-2023.components.organisms.card';

export interface ExpertHandleCardProps {
  onFindAgent?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const ExpertHandleCard: React.FC<ExpertHandleCardProps> = ({
  onFindAgent,
  className,
  style,
}) => {
  return (
    <Card
      className={className || ''}
      style={{
        background: '#f9f9ff',
        padding: '32px 24px',
        height: 248,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        ...style,
      }}
    >
      <div>
        <Typography
          variant='h6'
          style={{
            color: '#222222',
            fontWeight: 700,
            marginBottom: 16,
            fontSize: '20px',
            lineHeight: '28px',
          }}
        >
          Let an expert handle it
        </Typography>
        <Typography
          variant='body2'
          style={{
            color: '#757575',
            fontSize: '16px',
            lineHeight: '24px',
            marginBottom: 24,
          }}
        >
          Connect with a local agent to manage screening, leasing, and paperwork
          for you.
        </Typography>
      </div>
      <div>
        <Button
          variant='outlined'
          color='primary'
          size='large'
          onClick={onFindAgent}
          style={{
            backgroundColor: '#ffffff',
            color: '#222222',
            borderColor: '#222222',
            fontWeight: 600,
            fontSize: '16px',
            padding: '13px 32px',
            borderRadius: 8,
            textTransform: 'none',
            height: 50,
            minWidth: 200,
          }}
        >
          Find an Agent
        </Button>
      </div>
    </Card>
  );
};
